<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <NewsForm @submit-requested="submitRequested"></NewsForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import NewsForm from './NewsForm.vue'

  export default {
  components: { NewsForm },
  methods: {
    ...mapActions('news', ['postNews']),
    submitRequested (input) {
      this.postNews(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 